import React from "react";
import { useHardCode } from "../../hooks";
import "./item_card.css";
export const ItemCard = ({
  label,
  imageSrc = "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png",
  value,
  name,
  variants,
  labelClass,
  redirectedFromShopify,
  itemQty,
}) => {
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME } = useHardCode();
  const defaultContent = (
    <>
      <div className="item_card_left_content">
        <span className={`${labelClass} item_label`}>{label}</span>
        <img src={imageSrc} className="item_image" alt="product image" />
      </div>
      <div className="item_card_right_content">
        {SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female ? null : (
          <div>{value}</div>
        )}
        <div className="item_card_name_variants">
          <div>{name}</div>
          <div>{variants}</div>
        </div>
      </div>
    </>
  );

  const ShopifyContent = (
    <>
      <div className="item_card_left_content">
        <span className={`${labelClass} item_label`}>{label}</span>
        <img src={imageSrc} className="item_image" alt="product image" />
      </div>
      <div className="item_card_right_content">
        <div>
          {name} X {itemQty}
        </div>
        <div className="item_card_name_variants">
          {SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female ? null : (
            <div>{value}</div>
          )}
          <div>{variants}</div>
        </div>
      </div>
    </>
  );
  return (
    <div className="item_card_content">
      {redirectedFromShopify ? ShopifyContent : defaultContent}
    </div>
  );
};
